module.exports = moment;


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 207
 ** module chunks = 0
 **/